export default __webpack_public_path__ + "static/media/risk-gold.927bdf09.svg";